export interface AnalyticsState<T> {
    analytics?: T;
    loading?: boolean;
    error?: any;
}

type AnalyticsAction<T> =
    { type: 'set-analytics', payload: T | undefined } |
    { type: 'set-loading', payload?: boolean } |
    { type: 'set-error', payload?: any };

export const analyticsReducer = (state: AnalyticsState<any>, action: AnalyticsAction<any>): AnalyticsState<any> => {
    switch (action.type) {
        case 'set-analytics':
            return { ...state, analytics: action.payload, loading: false, error: undefined };
        case 'set-loading':
            return { ...state, loading: action.payload ?? true };
        case 'set-error':
            return { ...state, error: action.payload, loading: false };
        default:
            return state;
    }
};
